import LoginJira from "./LoginJira";

export default LoginJira;
